import { useMutation } from '@tanstack/react-query';
import { updateInboxFilterTags } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateInboxFilterTagsMutation = () =>
  useMutation({
    mutationFn: async (ids: ID[]) => updateInboxFilterTags(ids),
  });
